
import themes from "@/mixins/themes"
import jobDetails from "@/mixins/job/jobDetails"

export default {
    name: "JobPageBaseInfoBlocks",
    mixins: [jobDetails, themes],
    props: {
        job: {
            type: Object,
            required: true,
        },
    },
    computed: {
        blockStyle() {
            return {
                backgroundColor: `${this.oaTheme.accentText.color}15`,
                color: this.oaTheme.accentText.color,
            }
        },
        salariesRange() {
            const salaries =
                this.salaries.length > 0
                    ? [...this.salaries]
                    : [this.job.estimated_salary.avg]
            salaries.sort((a, b) => a - b)
            // Show only first and last salary
            return salaries
                .filter((_, idx) => idx === 0 || idx === salaries.length - 1)
                .map((s) => `${s}€`)
                .join(" - ")
        },
    },
}
